import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'percentage-renderer',
    templateUrl: './percentage-renderer.component.html',
    standalone: false
})
export class PercentageRendererComponent implements ICellRendererAngularComp {
    public amount: number;

    initilize(params: ICellRendererParams) {
        this.amount = params.getValue();
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
